import React, { useState } from 'react';
import { ProgressLabel, StyledCardWrapper } from './GroupGiftingCard.styles';
import { Flex } from '@components/Flex';
import { ProgressBar } from './components/ProgressBar';
import { CloudImage } from '@components/CloudImage';
import { Card } from '@sections/registry/components';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { useTranslation } from 'react-i18next';

export const GroupGiftingCard = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation('registry');
  const groupGiftingCard = t('registryCashFundSection.groupGiftingCard');
  return (
    <StyledCardWrapper>
      <LazyLoadWrapper beforeLoad={() => setIsVisible(true)}>
        <></>
      </LazyLoadWrapper>
      <Card
        eyebrow={groupGiftingCard.eyebrow}
        eyebrowVariant="featureHed17"
        eyebrowColor="white"
        title={groupGiftingCard.title}
        titleVariant="calloutHed32"
        titleColor="white"
        wrapperStyles={{
          background: `url(${
            isVisible ? cloudAssetUrl('registry-q12024/does-more/bkg-groupgift@2x.jpg', { optimization: 'default' }) : ''
          }) 0% 75%/ cover no-repeat, linear-gradient(0deg, rgba(0, 0, 0, 0.30) 0%, rgba(0, 0, 0, 0.30) 100%), lightgray 50%`,
        }}
      >
        <Flex flexDirection="row" justifyContent="space-between" alignItems="flex-end" marginTop={2}>
          <CloudImage src="/registry-q12024/does-more/chat-bubbles.svg" alt="chat-bubbles" optimization="default" />
          <ProgressLabel tagName="span" variant="dek20">
            {groupGiftingCard.progressLabel}
          </ProgressLabel>
        </Flex>
        <ProgressBar backgroundColor="white" fillColor="blue4" progressWidth="40%" />
      </Card>
    </StyledCardWrapper>
  );
};
